/**
* Scrolling Panels Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Panels Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-panels-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.scrolling-panels-content' ).each( function( key, val ) {
        const totalComponents = $( '.main > section' ).length;
        let thisKey = null;
        let refreshPriority = 0;
        $( '.main > section' ).each( function( componentKey, componentVal ) {
          if ( componentVal == val ) {
            thisKey = componentKey;
            refreshPriority = totalComponents - thisKey;
          }
        } );

        const imagePanel = $( this ).find( '.image-wrapper' )[0];
        const overlayBlock = $( this ).find( '.overlay-block' )[0];
        let totalPanelHeight = 0;
        $( this ).find( '.panel' ).each( function( panelKey, panel ) {
          totalPanelHeight += $( panel ).height();
        } );
        const singlePanelHeight = $( this ).find( '.panel' ).first().height();
        totalPanelHeight += singlePanelHeight;
        const height = $( this ).height( totalPanelHeight + singlePanelHeight );

        const pinImagePanel = gsap.timeline( {
          scrollTrigger: {
            trigger: imagePanel,
            start: 'bottom bottom',
            end: '+=' + totalPanelHeight,
            scrub: 0,
            pin: imagePanel,
            refreshPriority: refreshPriority,
          },
        } );

        const showOverlay = gsap.timeline( {
          scrollTrigger: {
            trigger: imagePanel,
            start: 'bottom bottom',
            end: '+=' + singlePanelHeight,
            scrub: true,
            refreshPriority: refreshPriority,
          },
        } );

        showOverlay.to( overlayBlock, {opacity: '0.8', ease: 'linear'}, 0 );

        $( this ).find( '.panel' ).each( function( panelKey, panel ) {
          const offset = $( panel ).height() * ( panelKey + 1 );

          const pinPanels = gsap.timeline( {
            scrollTrigger: {
              trigger: '.panels-wrapper',
              start: 'top top',
              end: '+=' + ( totalPanelHeight - $( panel ).outerHeight() ),
              scrub: 0,
              pin: '.panels-wrapper',
              refreshPriority: refreshPriority,
            },
          } );

          const showPanel = gsap.timeline( {
            scrollTrigger: {
              trigger: panel,
              start: offset + ' ' + $( panel ).height(),
              end: '+=' + ( $( panel ).height() - ( $( panel ).height() * 0.75 ) ),
              scrub: 0,
              refreshPriority: refreshPriority,
              immediateRender: false,
            },
          } );
          showPanel.to( panel, {opacity: '1', ease: 'linear'} );

          const hidePanel = gsap.timeline( {
            scrollTrigger: {
              trigger: panel,
              start: ( offset + ( $( panel ).height() / 2 ) ) + ' ' + $( panel ).height(),
              end: '+=' + ( $( panel ).height() - ( $( panel ).height() / 2 ) ),
              scrub: 0,
              refreshPriority: refreshPriority,
              immediateRender: false,
            },
          } );
          hidePanel.to( panel, {opacity: '0', ease: 'linear'}, 0 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-panels-content', COMPONENT );
} )( app );
